import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import { setAuthorizationObject } from "../../utils/api";
import Tooltip from '@material-ui/core/Tooltip';

const LoginAuthToken = (): JSX.Element => {
  const history = useHistory();
  return (
    <div className="container w-100 h-100">
      <div className="modal-content w-50 mx-auto">
        <Formik
          initialValues={{ token: "", subscriberCode:"" }}
          onSubmit={(values) => {
              setAuthorizationObject(values);
              history.push("/usageevent");
          }}
          validationSchema={ServicesSchema}
        >
          {({ isSubmitting, dirty, errors, touched }) => {
            const isValid = isSubmitting || !dirty;
            const hasError = errors.token !== undefined && touched.token;
            return (
              <Form className="w-100 h-100 modal-form">
                <div className="modal-header">
                  <h4 className="m-0 p-0 title">Token</h4>
                </div>
                <div className="modal-body">
                  <label>In order to have access the usage event explorer application, please insert token</label>
                  <div className={`${hasError ? "error-container" : ""} `}>
                    <Field as="textarea" type="text" name="token" placeholder="token" className="form-group form-control" />
                    <div className="error-message text-danger">
                      <ErrorMessage name="token" />
                    </div>                   
                  </div>
                  <hr/>
                  <Tooltip title="subscriber code must for payment engine" placement="bottom">
                    <div>
                      <label>Please insert subscriber code</label>
                      <Field type="text" name="subscriberCode" placeholder="subscriber code" className="form-group form-control" />
                    </div>
                  </Tooltip>
                </div>
                <div className="modal-footer">
                  <button className={`btn btn-red-outline ${isValid ? "disabled" : ""}`} type="submit">
                    Authorize
                  </button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default LoginAuthToken;

const ServicesSchema = Yup.object().shape({
  token: Yup.string().required("Token is required"),
});
